<template>
  <div>
    <input type="text" v-model="searchText" placeholder="Номер телефона или заявка" class="form-control">
    <div class="mt-1">
      <div class="card" v-for="o in orders">
        <div class="card-body p-1">
          <div class="mb-0 flex justify-content-between">
            <div>
              <button
                @click="openOrderToEdit(o.id)"
                class="btn btn-xs btn-info mr-1"
              ><i class="icon-fa icon-fa-eye"></i>
              </button>
              {{ o.id }}
              <OrderStatus :status="o.status"/>
              <span class="badge badge-info">{{ o.project_label}}</span>
            </div>
            <div v-if="selectedChat && !selectedChat.order_id">
              <LoadingButton
                title="Привязать к чату"
                className="btn btn-outline-success btn-xs"
                :onClick="() => linkChat(o.id)"
                :loading="btnLoading"
                :color="$constants.SUCCESS_COLOR"
              />
            </div>
          </div>
          <p class="mb-0">Планируемая доставка: <strong>{{ printDate(o.delivery_date, 'DD.MM.YYYY') }}</strong></p>
          <p>стоимость заявки <span class="badge badge-success">{{ o.price }}</span></p>

          <label class="text-muted">Препараты</label>
          <div v-for="d in o.details" class="border-bottom p-1 mb-1 bg_light_gray">
            <p class="mb-0">{{ d.drug.title }} <strong>x {{ d.qty }}</strong></p>

            <DrugStoreStatus
              :storeId="o.store_id"
              :storeStatus="storeStatus?.[d.drug.id]?.remain ?? {}"
            />

            <div class="invoice_data">
              <template v-for="i in getInvoicesToDivision(o.store_id, d.drug_id)">
                <p>Накладная: <strong>{{ i.id }}</strong> ({{ +i.qty }}уп.) в дороге на {{
                    printDate(i.delivery_date, 'DD.MM')
                  }}
                </p>
                <template v-if="!i.track">
                  <p><strong>не добавлен track номер!</strong></p>
                </template>
                <template v-else>
                  <template v-if="(i.extra_data?.flippost?.info ?? []).length">
                    <p>{{ i.extra_data.flippost.info[0].scity }} - {{ i.extra_data.flippost.info[0].rcity }}</p>
                    <template v-if="i.extra_data.flippost.info[0].dod">
                      <p>Накладная доставлена (ТК):
                        <strong>{{ printDateByFormat(i.extra_data.flippost.info[0].dod) }}</strong></p>
                    </template>
                    <template v-else>
                      <p>Планируемая дата доставки (ТК):
                        <strong>{{ printDateByFormat(i.extra_data.flippost.info[0].dtd) }}</strong></p>
                    </template>
                    <!--                    <div class="mt-1" v-if="(i.extra_data?.flippost?.track ?? []).length">-->
                    <!--                      <div v-for="t in i.extra_data.flippost.track" class="border-bottom">-->
                    <!--                        <p>{{ t.trackinfo }}</p>-->
                    <!--                      </div>-->
                    <!--                    </div>-->
                  </template>
                  <template v-else>
                    <p>Нет данных c ТК!</p>
                  </template>
                  <p v-if="i.extra_data?.flippost?.updated_at" class="text-muted text-right">
                    {{ printDate(i.extra_data.flippost.updated_at, 'DD.MM.YYYY HH:mm', false, 1) }}</p>
                </template>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import moment from 'moment';
import api from "@/api";
import OrderStatus from "@/components/orders/ordersData/OrderStatus.vue";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import StoreDataForOrder from "@/components/drugs/StoreDataForOrder.vue";
import DrugStoreStatus from "@/components/chat/components/DrugStoreStatus.vue";

export default {
  components: {DrugStoreStatus, StoreDataForOrder, LoadingButton, OrderStatus},
  props: ['projectId', 'selectedChat'],
  data() {
    return {
      searchText: null,
      orders: [],
      invoices: {},
      storeStatus: {},
      btnLoading: false,
    }
  },
  watch: {
    'searchText': {
      handler: function (val, oldVal) {
        this.getOrderInfo();
      }
    }
  },
  methods: {
    async linkChat(orderId) {
      this.btnLoading = true;
      const {data} = await api.post('/clientChats/chat/' + this.selectedChat.id, {
        order_id: orderId,
        action: 'linkOrder'
      });
      if (data.success) {
        this.selectedChat.order_id = orderId;
        toastr['success']('Сохранено', 'Успешно!');
      } else {
        toastr['warning'](data.message ?? 'Ошибка сервера', 'Ошибка!');
      }
      this.btnLoading = false;
    },
    printDateByFormat(date) {
      return moment(date, 'MMM DD YYYY, hh:mm:00:000A').format('DD.MM.YYYY');
    },
    getInvoicesToDivision(storeId, drugId) {
      return Object.values(this.invoices).filter((i) => {
        i.store_in === +storeId && i.drug_id === +drugId
        return i;
      });
    },
    async getOrderInfo() {
      if (!this.searchText) return;
      try {
        const {data} = await api.post('/new/orders/delivery/status', {
          search: this.searchText,
          project_id: this.projectId
        });
        if (data.success) {
          this.storeStatus = data.storeStatus;
          this.invoices = data.invoices_in_progress;
          this.orders = data.orders;
        } else {
          toastr['warning'](data.message ?? 'Ошибка сервера', 'Ошибка!');
        }
      } catch (e) {
        toastr['warning'](e, 'Ошибка!');

      }
    }
  }
}

</script>

<style scoped>
.invoice_data p {
  margin-bottom: 0;
}

.bg_light_gray {
  background-color: #e9ecef59;
}
</style>
